var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.termPopup.show ? _c('div', {
    staticClass: "term-popup-overlay"
  }, [_c('div', {
    staticClass: "term-popup-card"
  }, [_c('TongxinHeader'), _c('div', {
    staticClass: "term-popup-content page"
  }, [_vm.termsLoading ? _c('div', {
    staticClass: "term-popup-loading"
  }, [_vm._v("條款載入中...")]) : [_vm.termsPage.formTitle ? _c('div', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.termsPage.formTitle))]) : _vm._e(), _vm.termsPage.formDesc ? _c('div', {
    staticClass: "page-desc"
  }, [_vm._v(" " + _vm._s(_vm.termsPage.formDesc) + " ")]) : _vm._e(), _vm.terms.length > 0 ? _c('div', _vm._l(_vm.terms, function (term, index) {
    return _c('div', {
      key: "".concat(term.code || 'term', "-").concat(index),
      class: index !== _vm.terms.length - 1 ? 'term-item term-item-gap' : 'term-item'
    }, [_c('Accordion', {
      attrs: {
        "title": term.title
      }
    }, [_c('div', {
      staticClass: "term-vhtml",
      domProps: {
        "innerHTML": _vm._s(term.content)
      }
    })]), _c('Checkbox', {
      attrs: {
        "name": 'checkbox' + index
      },
      model: {
        value: _vm.checked[index],
        callback: function callback($$v) {
          _vm.$set(_vm.checked, index, $$v);
        },
        expression: "checked[index]"
      }
    }, [_vm._v(" " + _vm._s(_vm.checkboxWording) + " ")])], 1);
  }), 0) : _c('div', {
    staticClass: "term-popup-empty"
  }, [_vm._v("目前沒有可顯示的條款內容。")])]], 2), _vm.termPopup.errorMessage ? _c('p', {
    staticClass: "term-popup-error"
  }, [_vm._v(" " + _vm._s(_vm.termPopup.errorMessage) + " ")]) : _vm._e(), _c('div', {
    staticClass: "page-button"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "disabled": _vm.termPopup.isSubmitting || _vm.termsLoading || !_vm.isAllChecked
    },
    on: {
      "click": _vm.onTermPopupNext
    }
  }, [_vm._v(" " + _vm._s(_vm.termsPage.buttonText) + " ")])])], 1)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }